import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toIso = (d) => (d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "");
const fromIso = (s) => { if (!s) return undefined; const [y, m, d] = s.slice(0, 10).split("-").map(Number); return y && m && d ? new Date(y, m - 1, d) : undefined; };

/** Dark-mode-safe date picker (same calendar as the FRS / Mobilizations). value/onChange are ISO dates. */
export default function DateField({ value, onChange, disabled = false, placeholder = "Pick a date", className = "", testId = "date-field" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid={testId}
                className={`inline-flex h-8 w-full items-center gap-1.5 rounded-md border border-slate-200 bg-white px-2 text-left text-xs text-slate-800 hover:border-[#007BFF] disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 ${className}`}>
          <CalendarDays className="h-3.5 w-3.5 text-slate-400" />
          {value ? value.slice(0, 10) : <span className="text-slate-400">{placeholder}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-2" data-testid={`${testId}-popover`}>
        <Calendar mode="single" selected={fromIso(value)} defaultMonth={fromIso(value) || new Date()}
                  onSelect={(d) => { onChange(toIso(d)); setOpen(false); }} className="p-1" />
        {value && <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="mt-1 w-full text-[11px] text-slate-500 hover:underline">Clear</button>}
      </PopoverContent>
    </Popover>
  );
}
